import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { GlobalsService } from './shared/globals.service';
import { Subscription } from 'rxjs';
import { NgProgress } from '@ngx-progressbar/core';
import { AuthService } from './_authentication/auth';
import { Router } from '@angular/router';

@Component({
    selector: 'nepraunik-app',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.css'],
    moduleId: module.id
})
export class AppComponent implements AfterViewInit {
    public options = {
        position: ["top", "right"],
        timeOut: 4000,
        lastOnBottom: true,
    }

    public busy: Boolean = false;
    constructor(private globalsService: GlobalsService, public progress: NgProgress, public authService: AuthService, private router: Router, private changeDetector: ChangeDetectorRef) {

    }

    ngAfterViewInit() {
        this.globalsService.IsBusy.subscribe((value) => {
            if (value && !this.busy) {
                this.progress.start();
                setTimeout(() => {
                    this.busy = true;
                });
            }
            else {
                this.progress.complete();
                setTimeout(() => {
                    this.busy = false;
                });
            }
        });
    }

    public onNavigate(route) {
        this.router.navigate([route]);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts